var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 md12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.estado.label,
                              items: _vm.optionslist,
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.estado.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.estado, "value", $$v)
                              },
                              expression: "formFields.estado.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm2: "", md2: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c("v-flex", {
                        attrs: { sm5: "", md5: "", align: "rigth" }
                      }),
                      _c(
                        "v-flex",
                        { attrs: { sm1: "", md1: "", align: "rigth" } },
                        [
                          _c(
                            "div",
                            { staticClass: "text-sm-center botones-filtros" },
                            [
                              _vm.accionExportar.visible
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        small: "",
                                        color: "primary"
                                      },
                                      on: { click: _vm.btn_exportar }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "importExportBtnIcon" },
                                        [_vm._v("cloud_download")]
                                      ),
                                      _vm._v("  \n                "),
                                      _c(
                                        "span",
                                        { staticClass: "importExportBtnTexto" },
                                        [
                                          _vm._v("Exportar"),
                                          _c("br"),
                                          _vm._v("CSV")
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm1: "", md1: "", align: "rigth" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                "padding-right": "20px",
                                display: "block",
                                margin: "0 0 0 auto",
                                "margin-top": "15px"
                              },
                              attrs: { color: "#ffe800" },
                              on: { click: _vm.crear_equipo }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { color: "black" },
                                  attrs: { dark: "", left: "" }
                                },
                                [_vm._v("add_circle_outline")]
                              ),
                              _c("span", { staticStyle: { color: "black" } }, [
                                _vm._v("Crear")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              label: "Buscar...",
                              "append-icon": "search",
                              clearable: ""
                            },
                            on: { input: _vm.searchData },
                            model: {
                              value: _vm.filtrobusquedagrilla,
                              callback: function($$v) {
                                _vm.filtrobusquedagrilla = $$v
                              },
                              expression: "filtrobusquedagrilla"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.dialog
        ? _c("VerCrearModal", {
            on: { cerrarCrear: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.dialog2
        ? _c("VerEditarModal", {
            attrs: { codigoEquipo: _vm.codigoEquipo },
            on: { cerrarCrear: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.ShowHistorico
        ? _c("HistoricoTipoEquipo", {
            attrs: {
              editedId: _vm.selectedId,
              nombre: _vm.selectedNombre,
              codigo: _vm.codigo
            },
            on: { cerrarHistorial: _vm.handleCierreModalCrear }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }